import { render, staticRenderFns } from "./CamaraRegistroPantalla.vue?vue&type=template&id=4cab1a4f&scoped=true&"
import script from "./CamaraRegistroPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraRegistroPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cab1a4f",
  null
  
)

export default component.exports